/*!
 * Wilson Diamond Brokers — AI Ring Builder (front end)
 * Mounts into <div id="wdb-ring-builder" data-api="https://YOUR-WORKER.workers.dev"></div>
 * Leave data-api empty to run in demo mode (no AI calls, no emails).
 */
(function () {
  'use strict';

  var MAX_REFS = 3;
  var SESSION_RENDER_CAP = 15;

  var OPTIONS = {
    shape: ['Round', 'Oval', 'Cushion', 'Elongated cushion', 'Emerald', 'Radiant', 'Pear', 'Marquise', 'Princess', 'Asscher'],
    setting: ['Solitaire', 'Hidden halo', 'Halo', 'Three-stone', 'Pavé band', 'Bezel', 'Toi et moi'],
    metal: ['Yellow gold', 'White gold', 'Rose gold', 'Platinum', 'Two-tone'],
    carat: ['Under 1 ct', '1 ct', '1.5 ct', '2 ct', '2.5 ct', '3 ct', '4 ct+'],
    band: ['Thin & polished', 'Classic polished', 'Brushed', 'Pavé diamonds', 'Bold & wide'],
  };
  var LABELS = { shape: 'Diamond shape', setting: 'Setting style', metal: 'Metal', carat: 'Approx. carat', band: 'Band' };

  var SUGGESTIONS = ['Make the band thinner', 'Add a hidden halo', 'Switch to platinum', 'Larger center stone', 'Add pavé on the band', 'Show it from the side'];

  var LOADING_LINES = ['Selecting your center stone…', 'Shaping the setting…', 'Polishing the metal…', 'Adding the sparkle…', 'Almost ready…'];

  var CSS = `
:host{all:initial;display:block;--ink:#0b0b0b;--paper:#ffffff;--soft:#f6f5f1;--line:#e4e1d8;--muted:#6b675e;--gold:#EFE3A4;--gold-deep:#b8a55a;--err:#9b2c2c;
  font-family:"Cormorant Garamond",Garamond,Georgia,"Times New Roman",serif;color:var(--ink);font-size:18px;line-height:1.5}
*{box-sizing:border-box}
button,input,textarea,select{font:inherit;color:inherit}
.wrap{max-width:1180px;margin:0 auto;padding:24px 16px 48px}
.head{text-align:center;margin-bottom:28px}
.eyebrow{letter-spacing:.22em;text-transform:uppercase;font-size:12px;color:var(--muted)}
h1{font-size:clamp(32px,5vw,48px);font-weight:500;margin:6px 0 6px;line-height:1.1}
.sub{color:var(--muted);font-style:italic;margin:0}
.rule{width:56px;height:2px;background:var(--gold);margin:14px auto 0;border:0}
.grid{display:grid;grid-template-columns:minmax(0,1.1fr) minmax(0,1fr);gap:32px;align-items:start}
@media (max-width:860px){.grid{grid-template-columns:1fr;gap:22px}}
/* stage */
.stage{position:relative;aspect-ratio:1/1;background:var(--soft);border:1px solid var(--line);overflow:hidden;display:flex;align-items:center;justify-content:center}
.stage img{width:100%;height:100%;object-fit:cover;display:block}
.empty{text-align:center;padding:28px;color:var(--muted)}
.empty svg{width:88px;height:88px;margin-bottom:10px;opacity:.85}
.empty p{margin:0;font-size:20px;color:var(--ink)}
.empty small{display:block;margin-top:6px;font-size:16px}
.loading{position:absolute;inset:0;background:rgba(255,255,255,.82);backdrop-filter:blur(3px);display:none;flex-direction:column;align-items:center;justify-content:center;gap:14px;text-align:center;padding:20px}
.loading.on{display:flex}
.spinner{width:46px;height:46px;border:2px solid var(--line);border-top-color:var(--gold-deep);border-radius:50%;animation:spin 1s linear infinite}
@keyframes spin{to{transform:rotate(360deg)}}
.loading .line{font-size:20px}
.loading .hint{font-size:15px;color:var(--muted)}
.badge{position:absolute;top:12px;left:12px;background:var(--ink);color:var(--gold);font-size:12px;letter-spacing:.14em;text-transform:uppercase;padding:5px 10px}
.versions{display:flex;gap:8px;margin-top:12px;overflow-x:auto;padding-bottom:4px}
.versions button{flex:0 0 64px;height:64px;padding:0;border:1px solid var(--line);background:var(--soft);cursor:pointer;position:relative}
.versions button img{width:100%;height:100%;object-fit:cover;display:block}
.versions button[aria-current="true"]{outline:2px solid var(--ink);outline-offset:1px}
.versions span{position:absolute;bottom:2px;right:4px;font-size:11px;background:rgba(255,255,255,.85);padding:0 3px}
.disclaimer{font-size:14px;color:var(--muted);margin:12px 0 0;font-style:italic}
/* panel */
.panel{display:flex;flex-direction:column;gap:22px}
.step h2{font-size:22px;font-weight:600;margin:0 0 4px;display:flex;align-items:baseline;gap:10px}
.step h2 .n{font-size:13px;letter-spacing:.14em;color:var(--gold-deep);font-weight:600}
.step p.help{margin:0 0 10px;color:var(--muted);font-size:16px}
.drop{border:1px dashed #c9c4b5;background:var(--soft);padding:16px;text-align:center;cursor:pointer;transition:border-color .15s,background .15s}
.drop:hover,.drop.over{border-color:var(--ink);background:#fff}
.drop strong{font-weight:600}
.drop small{display:block;color:var(--muted);font-size:14px}
.refs{display:flex;gap:8px;margin-top:10px;flex-wrap:wrap}
.ref{position:relative;width:72px;height:72px;border:1px solid var(--line)}
.ref img{width:100%;height:100%;object-fit:cover}
.ref button{position:absolute;top:-8px;right:-8px;width:24px;height:24px;border-radius:50%;border:0;background:var(--ink);color:#fff;font-size:14px;line-height:24px;cursor:pointer;padding:0}
textarea,input[type=text],input[type=email],input[type=tel],select{width:100%;border:1px solid #cfcabd;background:#fff;padding:11px 12px;font-size:17px;border-radius:0;outline:none}
textarea:focus,input:focus,select:focus{border-color:var(--ink);box-shadow:0 0 0 3px rgba(239,227,164,.7)}
textarea{min-height:92px;resize:vertical}
.field{margin-bottom:12px}
.field label{display:block;font-size:14px;letter-spacing:.06em;text-transform:uppercase;color:var(--muted);margin-bottom:6px}
.chips{display:flex;flex-wrap:wrap;gap:6px}
.chip{border:1px solid #cfcabd;background:#fff;padding:6px 12px;font-size:16px;cursor:pointer;border-radius:999px;transition:all .12s}
.chip:hover{border-color:var(--ink)}
.chip[aria-pressed="true"]{background:var(--ink);color:#fff;border-color:var(--ink)}
.chip.sug{background:var(--soft)}
.btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:14px 22px;font-size:17px;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;border:1px solid var(--ink);background:var(--ink);color:#fff;transition:all .15s;border-radius:0}
.btn:hover{background:#262626}
.btn:disabled{opacity:.45;cursor:not-allowed}
.btn.ghost{background:transparent;color:var(--ink)}
.btn.ghost:hover{background:var(--soft)}
.btn.gold{background:var(--gold);color:var(--ink);border-color:var(--gold)}
.btn.gold:hover{background:#e6d687}
.btn.block{width:100%}
.row{display:flex;gap:10px;flex-wrap:wrap}
.row>*{flex:1 1 auto}
.linkish{background:none;border:0;padding:0;color:var(--muted);text-decoration:underline;cursor:pointer;font-size:15px}
.count{font-size:14px;color:var(--muted);text-align:right;margin-top:6px}
.msg{padding:10px 12px;font-size:16px;border-left:3px solid var(--err);background:#fbf3f3;color:var(--err);display:none}
.msg.on{display:block}
.hidden{display:none!important}
.sendbox{background:var(--ink);color:#fff;padding:20px;border-top:3px solid var(--gold)}
.sendbox h3{margin:0 0 4px;font-weight:500;font-size:22px}
.sendbox p{margin:0 0 14px;color:#d8d4c6;font-size:16px}
details.specs summary{cursor:pointer;font-size:16px;color:var(--muted);list-style:none}
details.specs summary::-webkit-details-marker{display:none}
details.specs summary::before{content:"+ ";}
details.specs[open] summary::before{content:"– ";}
details.specs .chipset{margin-top:12px}
.chipset{margin-bottom:14px}
.chipset .lbl{font-size:13px;letter-spacing:.1em;text-transform:uppercase;color:var(--muted);margin-bottom:6px}
/* modal */
.modal{position:fixed;inset:0;background:rgba(0,0,0,.55);display:none;align-items:center;justify-content:center;padding:16px;z-index:2147483000}
.modal.on{display:flex}
.card{background:#fff;max-width:520px;width:100%;max-height:92vh;overflow:auto;padding:26px 24px;border-top:3px solid var(--gold);position:relative}
.card h3{font-size:26px;font-weight:500;margin:0 0 4px}
.card p.lead{margin:0 0 18px;color:var(--muted)}
.close{position:absolute;top:10px;right:12px;background:none;border:0;font-size:26px;cursor:pointer;line-height:1;color:var(--muted)}
.fine{font-size:13px;color:var(--muted);margin-top:10px}
.thanks{text-align:center;padding:10px 0}
.thanks .seal{width:64px;height:64px;border-radius:50%;background:var(--ink);color:var(--gold);display:inline-flex;align-items:center;justify-content:center;font-size:30px;margin-bottom:10px}
.demo{background:var(--gold);color:var(--ink);text-align:center;font-size:15px;padding:8px 12px;margin-bottom:18px}
`;

  var RING_SVG =
    '<svg viewBox="0 0 100 100" fill="none" stroke="#b8a55a" stroke-width="2"><circle cx="50" cy="62" r="26"/><circle cx="50" cy="62" r="21" stroke-opacity=".5"/><path d="M38 30 L44 22 H56 L62 30 L50 44 Z" stroke="#0b0b0b"/><path d="M38 30 H62 M44 22 L47 30 L50 44 L53 30 L56 22" stroke="#0b0b0b" stroke-width="1.2"/></svg>';

  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'class') el.className = attrs[k];
      else if (k === 'text') el.textContent = attrs[k];
      else if (k === 'html') el.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') el.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== null && attrs[k] !== undefined) el.setAttribute(k, attrs[k]);
    }
    (children || []).forEach(function (c) { if (c != null) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }

  function store(key, val) {
    try { if (val === undefined) return localStorage.getItem('wdb-rb-' + key); localStorage.setItem('wdb-rb-' + key, val); } catch (e) { return null; }
  }

  function resizeImage(file, max) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = reject;
      reader.onload = function () {
        var img = new Image();
        img.onerror = function () { reject(new Error('Unreadable image')); };
        img.onload = function () {
          var s = Math.min(1, max / Math.max(img.width, img.height));
          var c = document.createElement('canvas');
          c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
          var ctx = c.getContext('2d');
          ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
          ctx.drawImage(img, 0, 0, c.width, c.height);
          resolve(c.toDataURL('image/jpeg', 0.9));
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  }

  function mount(host) {
    var API = (host.getAttribute('data-api') || '').replace(/\/+$/, '');
    var DEMO = !API;

    if (!document.getElementById('wdb-rb-font')) {
      var l = document.createElement('link');
      l.id = 'wdb-rb-font'; l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400&display=swap';
      document.head.appendChild(l);
    }

    var root = host.attachShadow ? host.attachShadow({ mode: 'open' }) : host;
    root.appendChild(h('style', { text: CSS }));

    var state = {
      specs: {}, refs: [], versions: [], current: -1, busy: false, rendersUsed: 0,
      name: store('name') || '', email: store('email') || '', pending: null,
    };

    /* ---------- layout ---------- */
    var wrap = h('div', { class: 'wrap' });
    root.appendChild(wrap);
    if (DEMO) wrap.appendChild(h('div', { class: 'demo', text: 'Preview mode — designs are sample images. Live AI renders turn on once the builder is connected.' }));

    wrap.appendChild(h('header', { class: 'head' }, [
      h('div', { class: 'eyebrow', text: 'Wilson Diamond Brokers' }),
      h('h1', { text: 'Design Your Ring' }),
      h('p', { class: 'sub', text: 'Your story, your stone. Imagine it here, and we’ll help bring it to life.' }),
      h('hr', { class: 'rule' }),
    ]));

    var grid = h('div', { class: 'grid' });
    wrap.appendChild(grid);

    // left: stage
    var stageImg = h('img', { alt: '', class: 'hidden' });
    var empty = h('div', { class: 'empty', html: RING_SVG + '<p>Your design will appear here</p><small>Upload a ring you love, describe your dream ring, or choose a few details.</small>' });
    var loadLine = h('div', { class: 'line', text: LOADING_LINES[0] });
    var loading = h('div', { class: 'loading', 'aria-live': 'polite' }, [h('div', { class: 'spinner' }), loadLine, h('div', { class: 'hint', text: 'Each design takes about 30–60 seconds.' })]);
    var badge = h('div', { class: 'badge hidden' });
    var stage = h('div', { class: 'stage' }, [empty, stageImg, badge, loading]);
    var versions = h('div', { class: 'versions', role: 'list', 'aria-label': 'Design versions' });
    grid.appendChild(h('div', {}, [stage, versions,
      h('p', { class: 'disclaimer', text: 'Designs are AI-generated concepts to capture your vision. Our team will review every detail with you, including the final diamond, proportions and pricing.' })]));

    // right: panel
    var panel = h('div', { class: 'panel' });
    grid.appendChild(panel);
    var errBox = h('div', { class: 'msg', role: 'alert' });

    /* start step */
    var fileInput = h('input', { type: 'file', accept: 'image/png,image/jpeg,image/webp', multiple: '', class: 'hidden' });
    var refsBox = h('div', { class: 'refs' });
    var drop = h('div', { class: 'drop', tabindex: '0', role: 'button', 'aria-label': 'Upload inspiration photos' }, [
      h('strong', { text: 'Upload inspiration photos' }),
      h('small', { text: 'Up to 3 images · JPG or PNG · or drag them here' }),
    ]);
    var desc = h('textarea', { placeholder: 'e.g. An elongated oval in a thin yellow gold band, with a hidden halo and a few tiny diamonds on the band…', 'aria-label': 'Describe your ring' });

    var specDetails = h('details', { class: 'specs', open: '' }, [h('summary', { text: 'Choose a few details (optional)' })]);
    Object.keys(OPTIONS).forEach(function (key) {
      var set = h('div', { class: 'chipset' }, [h('div', { class: 'lbl', text: LABELS[key] })]);
      var chips = h('div', { class: 'chips' });
      OPTIONS[key].forEach(function (opt) {
        var c = h('button', { type: 'button', class: 'chip', 'aria-pressed': 'false', text: opt });
        c.addEventListener('click', function () {
          var on = state.specs[key] === opt;
          chips.querySelectorAll('.chip').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          if (on) delete state.specs[key]; else { state.specs[key] = opt; c.setAttribute('aria-pressed', 'true'); }
        });
        chips.appendChild(c);
      });
      set.appendChild(chips);
      specDetails.appendChild(set);
    });

    var createBtn = h('button', { type: 'button', class: 'btn block', text: 'Create my design' });
    var startStep = h('section', { class: 'step' }, [
      h('h2', {}, [h('span', { class: 'n', text: '01' }), 'Start with inspiration']),
      h('p', { class: 'help', text: 'Share a photo, tell us what you’re dreaming of, or both.' }),
      drop, fileInput, refsBox,
    ]);
    var describeStep = h('section', { class: 'step' }, [
      h('h2', {}, [h('span', { class: 'n', text: '02' }), 'Describe it']),
      h('div', { class: 'field' }, [desc]),
      specDetails,
    ]);
    var createWrap = h('div', {}, [createBtn]);

    /* refine step */
    var refineInput = h('textarea', { placeholder: 'What would you like to change? e.g. “make the diamond a bit larger and switch to rose gold”', 'aria-label': 'Describe a change', style: 'min-height:76px' });
    var sugBox = h('div', { class: 'chips', style: 'margin:10px 0 12px' });
    SUGGESTIONS.forEach(function (s) {
      sugBox.appendChild(h('button', { type: 'button', class: 'chip sug', text: s, onclick: function () { refineInput.value = s; refineInput.focus(); } }));
    });
    var refineBtn = h('button', { type: 'button', class: 'btn', text: 'Update design' });
    var restartBtn = h('button', { type: 'button', class: 'btn ghost', text: 'Start over' });
    var countLine = h('div', { class: 'count' });
    var refineStep = h('section', { class: 'step hidden' }, [
      h('h2', {}, [h('span', { class: 'n', text: '03' }), 'Make it yours']),
      h('p', { class: 'help', text: 'Ask for any change in your own words. Each update builds on the design you’re viewing.' }),
      refineInput, sugBox, h('div', { class: 'row' }, [refineBtn, restartBtn]), countLine,
    ]);

    var sendBtn = h('button', { type: 'button', class: 'btn gold block', text: 'Send my design to WDB' });
    var sendBox = h('section', { class: 'sendbox hidden' }, [
      h('h3', { text: 'Love it?' }),
      h('p', { text: 'Send your design to our team. We’ll review it personally and email you with pricing. No obligation.' }),
      sendBtn,
    ]);

    panel.appendChild(errBox);
    panel.appendChild(startStep);
    panel.appendChild(describeStep);
    panel.appendChild(createWrap);
    panel.appendChild(refineStep);
    panel.appendChild(sendBox);

    /* ---------- modals ---------- */
    function modal(content) {
      var closeBtn = h('button', { class: 'close', type: 'button', 'aria-label': 'Close', html: '&times;' });
      var card = h('div', { class: 'card', role: 'dialog', 'aria-modal': 'true' }, [closeBtn].concat(content));
      var m = h('div', { class: 'modal' }, [card]);
      function close() { m.classList.remove('on'); }
      closeBtn.addEventListener('click', close);
      m.addEventListener('click', function (e) { if (e.target === m) close(); });
      root.appendChild(m);
      return { el: m, card: card, open: function () { m.classList.add('on'); var f = card.querySelector('input,textarea,select'); if (f) setTimeout(function () { f.focus(); }, 30); }, close: close };
    }

    // email gate
    var gName = h('input', { type: 'text', autocomplete: 'given-name', value: state.name });
    var gEmail = h('input', { type: 'email', autocomplete: 'email', value: state.email });
    var gErr = h('div', { class: 'msg', role: 'alert' });
    var gBtn = h('button', { type: 'button', class: 'btn block', text: 'Start designing' });
    var gate = modal([
      h('h3', { text: 'Before we begin' }),
      h('p', { class: 'lead', text: 'Where should we send your design? We’ll only use your email to help with your ring.' }),
      gErr,
      h('div', { class: 'field' }, [h('label', { text: 'First name' }), gName]),
      h('div', { class: 'field' }, [h('label', { text: 'Email' }), gEmail]),
      gBtn,
    ]);

    // send form
    var sName = h('input', { type: 'text', autocomplete: 'name' });
    var sEmail = h('input', { type: 'email', autocomplete: 'email' });
    var sPhone = h('input', { type: 'tel', autocomplete: 'tel', placeholder: 'Optional' });
    var sSize = h('input', { type: 'text', placeholder: 'If you know it' });
    var sTimeline = h('select', {}, ['Just exploring', 'Within 1 month', '1–3 months', '3–6 months', '6+ months'].map(function (t) { return h('option', { text: t }); }));
    var sNotes = h('textarea', { placeholder: 'Anything else we should know? Budget, diamond preferences (lab-grown or natural), the story behind it…' });
    var sErr = h('div', { class: 'msg', role: 'alert' });
    var sBtn = h('button', { type: 'button', class: 'btn gold block', text: 'Send to Wilson Diamond Brokers' });
    var sForm = h('div', {}, [
      h('h3', { text: 'Send your design' }),
      h('p', { class: 'lead', text: 'Our team will look over every detail and email you personally with pricing.' }),
      sErr,
      h('div', { class: 'field' }, [h('label', { text: 'Your name' }), sName]),
      h('div', { class: 'field' }, [h('label', { text: 'Email' }), sEmail]),
      h('div', { class: 'row' }, [h('div', { class: 'field' }, [h('label', { text: 'Phone' }), sPhone]), h('div', { class: 'field' }, [h('label', { text: 'Ring size' }), sSize])]),
      h('div', { class: 'field' }, [h('label', { text: 'Timeline' }), sTimeline]),
      h('div', { class: 'field' }, [h('label', { text: 'Notes' }), sNotes]),
      sBtn,
      h('p', { class: 'fine', text: 'Your final design and any inspiration photos you uploaded will be sent along with your request.' }),
    ]);
    var sThanks = h('div', { class: 'thanks hidden' }, [
      h('div', { class: 'seal', text: '✦' }),
      h('h3', { text: 'Thank you' }),
      h('p', { class: 'lead', text: 'Your design is on its way to our team. Watch your inbox. We’ll be in touch soon with pricing and next steps.' }),
      h('p', { style: 'font-style:italic', text: 'Creating moments that last a lifetime.' }),
    ]);
    var send = modal([sForm, sThanks]);

    /* ---------- behavior ---------- */
    function showError(box, text) { box.textContent = text || ''; box.classList.toggle('on', !!text); }

    function renderRefs() {
      refsBox.innerHTML = '';
      state.refs.forEach(function (src, i) {
        var rm = h('button', { type: 'button', 'aria-label': 'Remove photo', html: '&times;' });
        rm.addEventListener('click', function () { state.refs.splice(i, 1); renderRefs(); });
        refsBox.appendChild(h('div', { class: 'ref' }, [h('img', { src: src, alt: 'Inspiration photo ' + (i + 1) }), rm]));
      });
      drop.classList.toggle('hidden', state.refs.length >= MAX_REFS);
    }

    function addFiles(files) {
      showError(errBox, '');
      var list = Array.prototype.slice.call(files || []).filter(function (f) { return /^image\//.test(f.type); });
      list = list.slice(0, MAX_REFS - state.refs.length);
      Promise.all(list.map(function (f) { return resizeImage(f, 1024); }))
        .then(function (urls) { state.refs = state.refs.concat(urls); renderRefs(); })
        .catch(function () { showError(errBox, 'One of those photos couldn’t be read. Please try a JPG or PNG.'); });
    }

    drop.addEventListener('click', function () { fileInput.click(); });
    drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); } });
    fileInput.addEventListener('change', function () { addFiles(fileInput.files); fileInput.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('over'); }); });
    drop.addEventListener('drop', function (e) { addFiles(e.dataTransfer && e.dataTransfer.files); });

    function setBusy(on) {
      state.busy = on;
      loading.classList.toggle('on', on);
      [createBtn, refineBtn, sendBtn, restartBtn].forEach(function (b) { b.disabled = on; });
      if (on) {
        var i = 0; loadLine.textContent = LOADING_LINES[0];
        state.ticker = setInterval(function () { i = Math.min(i + 1, LOADING_LINES.length - 1); loadLine.textContent = LOADING_LINES[i]; }, 7000);
      } else clearInterval(state.ticker);
    }

    function show(index) {
      state.current = index;
      var v = state.versions[index];
      stageImg.src = v.image; stageImg.alt = 'Ring design version ' + (index + 1);
      stageImg.classList.remove('hidden'); empty.classList.add('hidden');
      badge.textContent = 'Version ' + (index + 1); badge.classList.remove('hidden');
      Array.prototype.forEach.call(versions.children, function (b, i) { b.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }

    function renderVersions() {
      versions.innerHTML = '';
      state.versions.forEach(function (v, i) {
        var b = h('button', { type: 'button', role: 'listitem', title: v.prompt || 'Version ' + (i + 1), 'aria-label': 'View version ' + (i + 1) }, [h('img', { src: v.image, alt: '' }), h('span', { text: String(i + 1) })]);
        b.addEventListener('click', function () { if (!state.busy) show(i); });
        versions.appendChild(b);
      });
    }

    function updateMode() {
      var has = state.versions.length > 0;
      startStep.classList.toggle('hidden', has);
      describeStep.classList.toggle('hidden', has);
      createWrap.classList.toggle('hidden', has);
      refineStep.classList.toggle('hidden', !has);
      sendBox.classList.toggle('hidden', !has);
      var left = Math.max(0, SESSION_RENDER_CAP - state.rendersUsed);
      countLine.textContent = left + ' design update' + (left === 1 ? '' : 's') + ' remaining';
      refineBtn.disabled = state.busy || left <= 0;
    }

    function summarizeStart() {
      var bits = [];
      if (desc.value.trim()) bits.push(desc.value.trim());
      var s = Object.keys(state.specs).map(function (k) { return LABELS[k] + ': ' + state.specs[k]; });
      if (s.length) bits.push(s.join(', '));
      if (state.refs.length) bits.push('(' + state.refs.length + ' inspiration photo' + (state.refs.length > 1 ? 's' : '') + ')');
      return bits.join(' — ') || 'Initial design';
    }

    function requestRender(opts) {
      if (state.rendersUsed >= SESSION_RENDER_CAP) {
        showError(errBox, 'You’ve reached the design limit for this visit. Send us your favorite version and we’ll take it from there!');
        return;
      }
      if (!state.email) { state.pending = opts; gate.open(); return; }
      showError(errBox, '');
      setBusy(true);
      var payload = {
        email: state.email,
        prompt: opts.prompt,
        specs: state.specs,
        references: opts.isStart ? state.refs : [],
        baseImage: opts.isStart ? null : state.versions[state.current].image,
      };
      var p = DEMO ? demoRender(payload) : fetch(API + '/api/render', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.error || 'Something went wrong.'); return d; }); });

      p.then(function (d) {
        state.rendersUsed++;
        state.versions.push({ image: d.image, prompt: opts.label, parent: opts.isStart ? -1 : state.current });
        renderVersions(); show(state.versions.length - 1);
        if (!opts.isStart) refineInput.value = '';
      }).catch(function (e) {
        showError(errBox, e.message || 'Something went wrong. Please try again.');
      }).then(function () { setBusy(false); updateMode(); });
    }

    createBtn.addEventListener('click', function () {
      if (!desc.value.trim() && !state.refs.length && !Object.keys(state.specs).length) {
        showError(errBox, 'Upload a photo, describe your ring, or choose a few details to begin.');
        return;
      }
      requestRender({ isStart: true, prompt: desc.value.trim(), label: summarizeStart() });
    });

    refineBtn.addEventListener('click', function () {
      var t = refineInput.value.trim();
      if (!t) { showError(errBox, 'Tell us what you’d like to change.'); refineInput.focus(); return; }
      requestRender({ isStart: false, prompt: t, label: t });
    });
    refineInput.addEventListener('keydown', function (e) { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) refineBtn.click(); });

    restartBtn.addEventListener('click', function () {
      if (state.versions.length && !confirmRestart()) return;
      state.versions = []; state.current = -1;
      renderVersions();
      stageImg.classList.add('hidden'); empty.classList.remove('hidden'); badge.classList.add('hidden');
      updateMode();
    });
    var restartArmed = false;
    function confirmRestart() {
      if (restartArmed) { restartArmed = false; restartBtn.textContent = 'Start over'; return true; }
      restartArmed = true; restartBtn.textContent = 'Tap again to clear';
      setTimeout(function () { restartArmed = false; restartBtn.textContent = 'Start over'; }, 3500);
      return false;
    }

    gBtn.addEventListener('click', function () {
      var n = gName.value.trim(), e = gEmail.value.trim();
      if (!n) return showError(gErr, 'Please enter your first name.');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e)) return showError(gErr, 'Please enter a valid email address.');
      showError(gErr, '');
      state.name = n; state.email = e; store('name', n); store('email', e);
      gate.close();
      if (state.pending) { var p = state.pending; state.pending = null; requestRender(p); }
    });
    [gName, gEmail].forEach(function (i) { i.addEventListener('keydown', function (e) { if (e.key === 'Enter') gBtn.click(); }); });

    sendBtn.addEventListener('click', function () {
      sName.value = sName.value || state.name; sEmail.value = sEmail.value || state.email;
      sForm.classList.remove('hidden'); sThanks.classList.add('hidden'); showError(sErr, '');
      send.open();
    });

    sBtn.addEventListener('click', function () {
      var name = sName.value.trim(), email = sEmail.value.trim();
      if (!name) return showError(sErr, 'Please enter your name.');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return showError(sErr, 'Please enter a valid email address.');
      showError(sErr, '');
      sBtn.disabled = true; sBtn.textContent = 'Sending…';
      var payload = {
        name: name, email: email, phone: sPhone.value, ringSize: sSize.value, timeline: sTimeline.value, notes: sNotes.value,
        specs: state.specs,
        finalImage: state.versions[state.current].image,
        references: state.refs,
        history: lineage(state.current),
      };
      var p = DEMO ? new Promise(function (r) { setTimeout(r, 900); }) : fetch(API + '/api/submit', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.error || 'Something went wrong.'); return d; }); });
      p.then(function () {
        sForm.classList.add('hidden'); sThanks.classList.remove('hidden');
        try { if (window.dataLayer) window.dataLayer.push({ event: 'wdb_ring_design_submitted' }); } catch (e) {}
      }).catch(function (e) { showError(sErr, e.message); })
        .then(function () { sBtn.disabled = false; sBtn.textContent = 'Send to Wilson Diamond Brokers'; });
    });

    function lineage(i) {
      var out = [];
      while (i > -1 && state.versions[i]) { out.unshift(state.versions[i].prompt); i = state.versions[i].parent; }
      return out;
    }

    /* ---------- demo mode ---------- */
    function demoRender(payload) {
      var pool = window.WDB_DEMO_IMAGES || [];
      var text = (payload.prompt + ' ' + JSON.stringify(payload.specs)).toLowerCase();
      var best = null, bestScore = -1;
      pool.forEach(function (d) {
        var s = 0;
        d.tags.forEach(function (t) { if (text.indexOf(t) > -1) s += 2; });
        if (payload.baseImage && d.src === payload.baseImage) s -= 5;
        s += Math.random();
        if (s > bestScore) { bestScore = s; best = d; }
      });
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve({ image: best ? best.src : 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="#f6f5f1"/>' + RING_SVG.replace(/^<svg[^>]*>|<\/svg>$/g, '') + '</svg>') });
        }, 2200);
      });
    }

    renderRefs();
    updateMode();
  }

  function init() {
    var nodes = document.querySelectorAll('#wdb-ring-builder, [data-wdb-ring-builder]');
    Array.prototype.forEach.call(nodes, function (n) { if (!n.__wdbMounted) { n.__wdbMounted = true; mount(n); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();